<template lang="pug">
  .single-histogram(ref="SingleHistogram")
</template>
<script>
// title: '直方图',
// histogramName1: 'T1',
// max: 100,
// toprichFontSize: 18,
// topFontSize: 20,
// sign: ''
export default {
  name: 'SingleHistogram',
  props: {
    opts: {
      type: Object,
      required: true
    },
    series: {
      required: false
    }
  },
  watch: {
    series: {
      deep: true,
      handler (val) {
        if (val) {
          this.updateSerise(val)
        }
      }
    }
  },
  computed: {
    options () {
      const SingleHistogramDefault = {
        title: '直方图',
        histogramName1: 'T1',
        max: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: ''
      }
      const resu = Object.assign(SingleHistogramDefault, this.opts)
      return resu
    }
  },
  data () {
    return {
      graph: null
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph () {
      this.graph = this.$echarts.init(this.$refs.SingleHistogram)
      this.graph.showLoading()
    },
    updateSerise (serise) {
      const that = this
      const option = {
        backgroundColor: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            },
            {
              offset: 1,
              color: 'rgba(255, 255, 255, 0)'
            }
          ]
        },
        color: ['#5c8cd3'],
        title: {
          text: that.options.title,
          left: '1%',
          top: '2%',
          textStyle: {
            color: '#000',
            fontWeight: '400'
          }
        },
        tooltip: {
          show: true
        },
        label: {
          normal: {
            show: true,
            fontSize: 30,
            color: '#000',
            position: 'top'
          }
        },
        itemStyle: {
          normal: {
            color: '#5c8cd3',
            borderWidth: 3,
            opacity: 1
          },
          emphasis: {
            color: '#5c8cd3'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          top: '20%',
          bottom: '10%',
          containLabel: false
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#bcd6ed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: []
        },
        yAxis: {
          max: function (value) {
            if (value.max > that.options.max) {
              return value.max * 1.3
            }
            return that.options.max + value.max * 0.3
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          type: 'value'
        },
        series: [
          {
            name: that.options.histogramName1,
            barWidth: '40%', // 柱图宽度
            type: 'bar',
            data: [40],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  distance: 5,
                  formatter: ['{a|{a}}', '   {c}' + that.options.sign].join(
                    '\n'
                  ),
                  rich: {
                    a: {
                      color: '#000',
                      fontSize: that.options.toprichFontSize
                    }
                  },
                  textStyle: {
                    color: '#000',
                    fontSize: that.options.topFontSize,
                    lineHeight: 20
                  }
                }
              }
            }
          }
        ]
      }
      var $data = serise
      var xA = []
      var xV = []
      for (var key in $data) {
        xA.push(key)
        xV.push($data[key])
      }
      option.xAxis.data = xA
      option.series[0].data = xV
      this.graph.hideLoading()
      this.graph.setOption(option)
      window.addEventListener('resize', function () {
        that.graph.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.single-histogram {
  width: 100%;
  height: 100%;
}
</style>
